import Http from "./http";

export const getAllProductListAPI = (data) => {
  return Http.post("admin/product/getProductList",data);
};
